import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { SHOP_ITEMS } from "@/data/content";
import { useT } from "@/i18n";

export default function ShopTeaser() {
  const t = useT();
  return (
    <section className="bg-[#fafafa] py-24 md:py-32" data-testid="shop-teaser">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="eyebrow">{t.shop.eyebrow}</p>
            <h2 className="heading-display mt-3 text-5xl sm:text-6xl lg:text-7xl uppercase">
              {t.shop.title1} <span className="text-[#C20E1A]">{t.shop.title2}</span>
            </h2>
            <p className="mt-6 max-w-xl text-base text-black/70">{t.shop.body}</p>
          </div>
          <a
            href="https://artful-merchandise.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="shop-visit-all"
            className="self-start md:self-auto inline-flex items-center gap-2 border-b-2 border-[#C20E1A] pb-2 text-[12px] uppercase tracking-[0.25em] font-bold text-black hover:text-[#C20E1A] transition-colors"
          >
            {t.shop.cta} <ArrowUpRight size={14} />
          </a>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {SHOP_ITEMS.map((item, i) => (
            <a
              key={item.title}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`shop-item-${i}`}
              className="group block bg-white"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                />
                <div className="absolute top-3 right-3 h-9 w-9 inline-flex items-center justify-center bg-white text-black opacity-0 group-hover:opacity-100 transition-opacity">
                  <ArrowUpRight size={16} />
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm sm:text-base font-bold tracking-tight text-black group-hover:text-[#C20E1A] transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs uppercase tracking-[0.2em] text-black/50">
                  {t.shop.productCaption}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
